// 画像アップロードの上限（Issue #156）。バックエンドの uploadMiddleware.ts と揃える
export const MAX_IMAGE_SIZE_MB = 3;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

// 圧縮設定（Issue #157）。ヘッダー背景・紹介シート背景は従来値のまま
export const DEFAULT_COMPRESSION_OPTIONS = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  alwaysKeepResolution: true,
};

// プロフィール画像は最大 160px 表示のため小さくする（Retina でも足りる 480px）
export const PROFILE_IMAGE_COMPRESSION_OPTIONS = {
  maxSizeMB: 0.2,
  maxWidthOrHeight: 480,
  useWebWorker: true,
  alwaysKeepResolution: true,
};
